export * from './redirect'



/** WEBPACK FOOTER **
 ** ./src/utils/redirect/index.js
 **/